import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'confirm_booking';
export const route = 'confirm_booking/[bookingId]/';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "flights_confirm_booking_page" */
/* webpackPrefetch: true */
'../components/ConfirmBookingPage')));